import { render, staticRenderFns } from "./FormConference.vue?vue&type=template&id=6954492a&"
import script from "./FormConference.vue?vue&type=script&lang=js&"
export * from "./FormConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports